import { render, staticRenderFns } from "./TaxWarrants.vue?vue&type=template&id=8c02ab52&"
import script from "./TaxWarrants.vue?vue&type=script&lang=js&"
export * from "./TaxWarrants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports